import { takeEvery, call, put } from "redux-saga/effects";
import { SubmissionError } from "redux-form";
import { isRequired, validateValues } from "../../utils/validation";
import { submitFormRoutine } from "./actions";
import AuthService from "../../services/auth";

function* validate({ payload: { values, props } }) {
  const errors = validateValues(values, {
    phone: [ isRequired ],
  });

  if (errors) {
    yield put(submitFormRoutine.failure(new SubmissionError(errors)));
  } else {
    yield call(sendFormDataToServer, values);
  }

  yield put(submitFormRoutine.fulfill());
}

function* sendFormDataToServer(values) {
  try {
    yield put(submitFormRoutine.request());
    const response = yield call(AuthService.login, values);
    // const response = true;
    if (response) {
      yield put(submitFormRoutine.success(values));
    }
  } catch (error) {
    if (error.errorCode === 1601) {
      yield put(submitFormRoutine.failure(new SubmissionError({ phone: 'Phone number is incorrect' })));
    }
    if (error.errorCode === 1004) {

      const message = `Please retry in ${error.errorMessage.split(" ").splice(-2).join(' ')}`;

      yield put(submitFormRoutine.failure(new SubmissionError({ _error: message })));
    }
    else {
      yield put(submitFormRoutine.failure(new SubmissionError({ _error: 'Request error' })));
    }

  }
}

export default [
  takeEvery(submitFormRoutine.TRIGGER, validate),
];
